<template>
  <modal-pro></modal-pro>
  <product-hero
    :bg="require('@/assets/banner-products.jpg')"
    code="<span class='colored'>CC</span>/<span class='colored'>LC</span>"
    :title="$t('products.lcccTitle')"
  ></product-hero>
  <product-line-item
    v-for="(item, idx) in products"
    :key="idx"
    :img="item.img"
    :name="item.name"
    :tagline="item.tagline"
    :slug="item.slug"
  ></product-line-item>
</template>

<script>
import ProductHero from "./../../components/ProductHero.vue";
import ProductLineItem from "./../../components/ProductLineItem.vue";
import ModalPro from "./../../components/ModalPro.vue";
import productDetails from "./../../data/productDetails.js";

export default {
  name: "LC",
  components : { ProductHero, ProductLineItem, ModalPro },
  computed : {
    contentLocale() {
      return this.$store.state.region === "us" ? "us" : this.$i18n.locale;
    },
    products() {
      const cedarElm = {
        img : productDetails.cage.heroImg,
        name : productDetails.cage.name,
        tagline : this.$t("cage.tagline", this.contentLocale),
        slug : productDetails.cage.slug
      };

      const walnut = {
        img : productDetails.walnut.heroImg,
        name : productDetails.walnut.name,
        tagline : this.$t("walnut.tagline", this.contentLocale),
        slug : productDetails.walnut.slug
      };

      return this.$i18n.locale === "fr" ? [walnut, cedarElm] : [cedarElm, walnut];
    }
  }
}
</script>
